import * as u from "react";
import { Children as y, useCallback as k } from "react";
import { jsx as e, jsxs as c, ObjectUtils as _, classNames as $, Fragment as P } from "./utils.esm.ea524c19.js";
import { FontAwesomeIcon as N, faChevronRight as x, faChevronLeft as j, faArrowRightFromBracket as L } from "./index.0c001ce2.js";
function R({
  width: i = "auto",
  className: r,
  style: n,
  header: l,
  headerClassName: a,
  headerStyle: t,
  children: o,
  contentClassName: d,
  contentStyle: p,
  footer: v,
  footerClassName: f,
  footerStyle: g
}) {
  let m = "bw-container";
  r && (m += ` ${r}`);
  let h = "bw-container-header";
  a && (h += ` ${a}`);
  let s = "bw-container-content";
  d && (s += ` ${d}`);
  let b = "bw-container-footer";
  return f && (b += ` ${f}`), /* @__PURE__ */ e("div", {
    className: m,
    style: {
      maxHeight: "85vh",
      width: `min(${i}, 85vw)`,
      ...n || {}
    },
    children: /* @__PURE__ */ c("div", {
      className: "bw-container-wrapper",
      children: [l ? /* @__PURE__ */ e("div", {
        className: h,
        style: t,
        children: l
      }) : null, /* @__PURE__ */ e("div", {
        className: s,
        style: p,
        children: o
      }), v ? /* @__PURE__ */ e("div", {
        className: b,
        style: g,
        children: v
      }) : null]
    })
  });
}
function C({
  children: i,
  cols: r = 3
}) {
  const n = y.toArray(i), [l, a] = r === 3 ? n.length > 4 ? [6, 3] : n.length > 1 ? [6, 6] : [12, 12] : n.length > 1 ? [6, 6] : [12, 12];
  return /* @__PURE__ */ e("div", {
    className: "grid",
    children: n.map((t) => /* @__PURE__ */ e("div", {
      className: `col-12 md:col-${l} lg:col-${a}`,
      children: t
    }, t.key))
  });
}
var w = /* @__PURE__ */ u.memo(/* @__PURE__ */ u.forwardRef(function(i, r) {
  var n = u.useRef(null), l = _.findDiffKeys(i, w.defaultProps), a = $("p-progress-spinner", i.className);
  return u.useImperativeHandle(r, function() {
    return {
      props: i,
      getElement: function() {
        return n.current;
      }
    };
  }), /* @__PURE__ */ e("div", {
    id: i.id,
    ref: n,
    style: i.style,
    className: a,
    role: "alert",
    "aria-busy": !0,
    ...l,
    children: /* @__PURE__ */ e("svg", {
      className: "p-progress-spinner-svg",
      viewBox: "25 25 50 50",
      style: {
        animationDuration: i.animationDuration
      },
      children: /* @__PURE__ */ e("circle", {
        className: "p-progress-spinner-circle",
        cx: "50",
        cy: "50",
        r: "20",
        fill: i.fill,
        strokeWidth: i.strokeWidth,
        strokeMiterlimit: "10"
      })
    })
  });
}));
w.displayName = "ProgressSpinner";
w.defaultProps = {
  __TYPE: "ProgressSpinner",
  id: null,
  style: null,
  className: null,
  strokeWidth: "2",
  fill: "none",
  animationDuration: "2s"
};
function A({
  className: i,
  style: r
}) {
  return /* @__PURE__ */ e(w, {
    className: i,
    style: r
  });
}
const D = ({
  account: i,
  links: r,
  isSidebarCollapsed: n,
  setIsSidebarCollapsed: l,
  header: a,
  onLinkClick: t,
  onProfileClick: o,
  onCompanyClick: d,
  onLogoutClick: p
}) => {
  var m, h;
  const v = window.location, f = k(() => l((s) => !s), [l]), g = {
    title: "Logout",
    onClick: p
  };
  return /* @__PURE__ */ c(P, {
    children: [/* @__PURE__ */ e("div", {
      className: `bw-sidebar-toggle${n ? " bw-sidebar-toggle-collapsed" : ""}`,
      onClick: f,
      children: /* @__PURE__ */ e(N, {
        icon: n ? x : j
      })
    }), /* @__PURE__ */ c("div", {
      className: `bw-sidebar${n ? " bw-sidebar-collapsed" : ""}`,
      children: [/* @__PURE__ */ e("div", {
        className: "bw-sidebar-header",
        children: a
      }), /* @__PURE__ */ e("div", {
        className: "bw-sidebar-links",
        children: r.map((s) => /* @__PURE__ */ c("div", {
          className: "bw-sidebar-links-module",
          children: [/* @__PURE__ */ e("div", {
            className: "bw-sidebar-links-label",
            children: s.label
          }), s.links.map((b) => /* @__PURE__ */ e(E, {
            ...b,
            location: v,
            navigate: t
          }, b.to))]
        }, s.mapping_key))
      }), /* @__PURE__ */ c("div", {
        className: "bw-sidebar-footer",
        children: [/* @__PURE__ */ c("div", {
          className: "bw-sidebar-profile",
          title: "Edit Profile",
          onClick: o,
          children: [/* @__PURE__ */ e("img", {
            src: i.profile_image_url,
            className: "bw-sidebar-profile-image",
            alt: ((m = i.display_name) == null ? void 0 : m.split(" ").map((s) => s[0]).join("")) || ""
          }), /* @__PURE__ */ e("div", {
            children: i.display_name
          }), /* @__PURE__ */ e("div", {
            className: d ? "bw-sidebar-switch-company" : void 0,
            title: d ? "Click to switch" : void 0,
            onClick: d,
            children: (h = i.company) == null ? void 0 : h.name
          })]
        }), /* @__PURE__ */ c("div", {
          className: "bw-sidebar-logout",
          ...n ? {} : g,
          children: [/* @__PURE__ */ e(N, {
            icon: L,
            ...n ? g : {}
          }), /* @__PURE__ */ e("span", {
            children: "Logout"
          })]
        })]
      })]
    })]
  });
}, E = ({
  icon: i,
  label: r,
  to: n,
  location: l,
  navigate: a
}) => {
  const t = k(() => a(n), [a, n]), o = l.pathname.startsWith(n);
  return /* @__PURE__ */ c("div", {
    className: "bw-sidebar-link" + (o ? " bw-active" : ""),
    title: r,
    onClick: t,
    children: [/* @__PURE__ */ e("div", {
      className: "bw-sidebar-link-icon",
      children: /* @__PURE__ */ e(N, {
        icon: i[o ? 1 : 0]
      })
    }), /* @__PURE__ */ e("div", {
      className: "bw-sidebar-link-text",
      children: r
    })]
  });
}, F = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Container: R,
  Grid: C,
  LoadingSpinner: A,
  Sidebar: D
}, Symbol.toStringTag, { value: "Module" }));
export {
  R as Container,
  C as Grid,
  A as LoadingSpinner,
  D as Sidebar,
  F as index
};
